import { render, staticRenderFns } from "./AnyDetail.vue?vue&type=template&id=6a018c0a&"
import script from "./AnyDetail.vue?vue&type=script&lang=js&"
export * from "./AnyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports